function defaultValueForProperty(property, hardwareName) {
    if (
        hardwareName != null &&
        property.defaults &&
        Object.prototype.hasOwnProperty.call(property.defaults, hardwareName)
    ) {
        return property.defaults[hardwareName]
    }
    return property.default
}

export function hardwareNameFromVersion(specHardware, hardwareVersion) {
    if (!specHardware || hardwareVersion == null) {
        return null
    }
    return Object.keys(specHardware).find(name => specHardware[name] === hardwareVersion) ?? null
}

export default function createDefaultConfig(features, hardwareName = null) {
    let defaultConfig = Object()

    for(const [featureName, feature] of Object.entries(features)) {
        defaultConfig[featureName] = Object()
        if(feature.property_groups) {
            for(const [propertyGroupName, propertyGroup] of Object.entries(feature.property_groups)) {
                if(feature[propertyGroupName] == null) { 
                    defaultConfig[featureName][propertyGroupName] = Object()
                }
                propertyGroup.byte_groups.forEach(byteGroup => {
                    for(const [propertyName, property] of Object.entries(byteGroup.properties)) {
                        defaultConfig[featureName][propertyGroupName][propertyName] = defaultValueForProperty(property, hardwareName)
                    }
                })
            }
        }
        if(feature.byte_groups) {
            feature.byte_groups.forEach(byteGroup => {
                for(const [propertyName, property] of Object.entries(byteGroup.properties)) {
                    defaultConfig[featureName][propertyName] = defaultValueForProperty(property, hardwareName)
                }
            })
        }
    }
    return defaultConfig
}
